module.exports = __webpack_public_path__ + "static/media/contact-left.81f31b0e.jpg";